(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
    {console.log();return window.console;}catch(err){return window.console={};}})());
    
    var formatMoney = "$ \{\{amount\}\}";
    
    var isMobile = {
        Android: function() {
            return navigator.userAgent.toLowerCase().match(/android/i);
        },
        BlackBerry: function() {
            return navigator.userAgent.toLowerCase().match(/blackberry/i);
        },
        iOS: function() {
            return navigator.userAgent.toLowerCase().match(/iphone|ipad|ipod/i);
        },
        Opera: function() {
            return navigator.userAgent.toLowerCase().match(/opera mini/i);
        },
        Windows: function() {
            return navigator.userAgent.toLowerCase().match(/iemobile/i);
        },
        any: function() {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
    };
    
    var fancyboxSettings = {
      hideOnContentClick: true,
      titleShow : true,
      padding : 0,
      margin:[40,52,40,52],
      nextEffect: 'fade',
      prevEffect: 'fade',
      closeEffect : 'fade',
      autoCenter: true,
      helpers: {
        overlay: {speedOut : 500, locked: true}
      },
      afterLoad: function() {
          $('html').addClass('fancybox-lock');
      },
      afterShow: function() {
        setTimeout(function(){
            $.fancybox.update();
        }, 200);
      }
    };
    
    jQuery(function($) {
        setTimeout(function(){
          $('.content-wrapper').css('padding-top', $('#header').height());
          $(window).resize(function(){          
            $('.content-wrapper').css('padding-top', $('#header').height());
          });
        }, 200);
    
          if(!isMobile.any()) {
          $('body').addClass('isNotMobile'); 
        }
    
          $(document).on("click", ".quantity .minus", function() {
              var wrapper = $(this).parent();
              var originalValue = wrapper.find('input[type=number]').val();
            try {
              wrapper.find('input[type=number]').get(0).stepDown();
              if(originalValue!=wrapper.find('input[type=number]').val()) {
                  wrapper.find('input[type=number]').change();
              }
            } catch(e) {
              var value = (parseInt(wrapper.find('input[type=number]').val())-1);
              wrapper.find('input[type=number]').val((value>=1 ? value : 1));
              if(originalValue!=wrapper.find('input[type=number]').val()) {
                  wrapper.find('input[type=number]').change();
              }
            }
          });
          $(document).on("click", ".quantity .plus", function() {
              var wrapper = $(this).parent();
              var originalValue = wrapper.find('input[type=number]').val();
            try {
              wrapper.find('input[type=number]').get(0).stepUp();
              if(originalValue!=wrapper.find('input[type=number]').val()) {
                  wrapper.find('input[type=number]').change();
              }
            } catch(e) {
              var value = (parseInt(wrapper.find('input[type=number]').val())+1);
              wrapper.find('input[type=number]').val(value);
              if(originalValue!=wrapper.find('input[type=number]').val()) {
                  wrapper.find('input[type=number]').change();
              }
            }
          });
    
          if($('#side-cart').length > 0) {
            initSideCart();
          }
    
          
              $('body').delegate('.add-to-cart-form', 'submit', function(){
                return validateAddCart($(this));
            });
          
          
          $(window).scroll(function(){
            if($(this).scrollTop()<=200) {
              $('.scrollup').fadeOut();
            } else {
              $('.scrollup').fadeIn();
            }
         
          
          
              if( $(this).scrollTop()>=30 ) {
                  $('#top-header').addClass('scroll');
            } else {
                $('#top-header').removeClass('scroll');
            }
        });
      
          $('a.scroll').click(function(){
            $.scrollTo($(this).attr('href'), 1000, {offset: -50});
            return false;
           });
        
          $(window).resize(function(){
              $.fancybox.update();
          });
    
          $("a[rel='fancybox']").fancybox(fancyboxSettings);
          
        
          $('#footer .mailing-list form').submit(function(e){
            e.preventDefault();
              e.stopImmediatePropagation();
    
              var form = $(this);
              $.ajax({
                  url: form.attr('action'),
                  data: form.serialize(),
                  type: 'POST'
            }).done(function(){
                $('#footer .mailing-list form').fadeOut(function(){
                    $('#footer .mailing-list .success').fadeIn();
                });
            });
        });
      
          $.ajax({
            url: '/pages/datetime?cache=false',
              cache: false
        }).done(function(resp){
              resp = $.trim(resp);
              eval('resp = '+resp);
              $(document).trigger("dateLoaded", resp);
        });
      
          $(document).on('dateLoaded', function(event, data){
              if(businessIsOpen(data)) {
                  var hours = businessWillClose(data);
                  $('.hours-left').html(hours + (hours>1 ? ' hours' : ' hour'));
    
                  $('#footer-wrapper .has-dropdown .ourhours .open').removeClass('hide');
                  $('#footer-wrapper .has-dropdown .ourhours .closed, #footer-wrapper .has-dropdown .ourhours .none').addClass('hide');
                $('#contact-fullscreen .open').removeClass('hide');
                  $('#contact-fullscreen .closed').addClass('hide');
                  $('.bottom-columns .chart-wrapper .contact .open').removeClass('hide');
                  $('.bottom-columns .chart-wrapper .contact .closed').addClass('hide');
                  $('.over-carousel .call-contact .open').removeClass('hide');
                  $('.over-carousel .call-contact .closed').addClass('hide');
                $('.chart-wrapper .call-contact .open').removeClass('hide');
                $('.chart-wrapper .call-contact .closed').addClass('hide');
            } else {
                  var hours = businessWillOpen(data);
                  $('.hours-to').html(hours + (hours>1 ? ' hours' : ' hour'));
              
                $('#footer-wrapper .has-dropdown .ourhours .open, #footer-wrapper .has-dropdown .ourhours .none').addClass('hide');
                  $('#footer-wrapper .has-dropdown .ourhours .closed').removeClass('hide');
                  $('#contact-fullscreen .open').addClass('hide');
                  $('#contact-fullscreen .closed').removeClass('hide');
                  $('.bottom-columns .chart-wrapper .contact .open').addClass('hide');
                  $('.bottom-columns .chart-wrapper .contact .closed').removeClass('hide');
                  $('.over-carousel .call-contact .open').addClass('hide');
                  $('.over-carousel .call-contact .closed').removeClass('hide');
                $('.chart-wrapper .call-contact .open').addClass('hide');
                $('.chart-wrapper .call-contact .closed').removeClass('hide');
            }
          })
    });
    
    function businessIsOpen(date) {
        var dayOfWeek = date.dayOfWeek;
        var hour = date.hour;
    
        var open = false;
        if(dayOfWeek==1 && hour>=10 && hour <= 18) { //Monday
            open = true;
        }
        if(dayOfWeek==2 && hour>=10 && hour <= 18) { //Tuesday
            open = true;
        }
        if(dayOfWeek==3 && hour>=10 && hour <= 18) { //Wednesday
            open = true;
        }
        if(dayOfWeek==4 && hour>=10 && hour <= 18) { //Thursday
            open = true;
        }
        /*if(dayOfWeek==5 && hour>=9 && hour <= 18) { //Friday
            open = true;
        }
        if(dayOfWeek==6 && hour>=11 && hour <= 17) { //Saturday
          open = true;
        }*/
          if(dayOfWeek==0 && hour>=11 && hour <= 17) { //Sunday
          open = true;
        }
    
        return open;
    }
    
    function businessWillClose(date) {
          var dayOfWeek = date.dayOfWeek;
        var hour = date.hour;
        var hoursLeft = 0;
      
          if(dayOfWeek==1) { //Monday
            hoursLeft = 18 - hour;
        }
        if(dayOfWeek==2) { //Tuesday
            hoursLeft = 18 - hour;
        }
        if(dayOfWeek==3) { //Wednesday
            hoursLeft = 18 - hour;
        }
        if(dayOfWeek==4) { //Thursday
            hoursLeft = 18 - hour;
        }
          if(dayOfWeek==0) { //Sunday
          hoursLeft = 17 - hour;
        }
    
          return hoursLeft;
    }
    
    function businessWillOpen(date) {
          var dayOfWeek = date.dayOfWeek;
        var hour = date.hour;
        var hoursLeft = 0;
      
          if(dayOfWeek==1) { //Monday
              if(hour < 10) {
                hoursLeft = 10 - hour;
              } else {
                  hoursLeft = 24 - hour + 10;
              }
        }
        if(dayOfWeek==2) { //Tuesday
            if(hour < 10) {
                hoursLeft = 10 - hour;
              } else {
                  hoursLeft = 24 - hour + 10;
              }
        }
        if(dayOfWeek==3) { //Wednesday
            if(hour < 10) {
                hoursLeft = 10 - hour;
              } else {
                  hoursLeft = 24 - hour + 10;
              }
        }
        if(dayOfWeek==4) { //Thursday
            if(hour < 10) {
                hoursLeft = 10 - hour;
              } else {
                  hoursLeft = (24 * 3) - hour + 10;
              }
        }
          if(dayOfWeek==5) { //Friday
            if(hour < 10) {
                hoursLeft = 10 - hour;
              } else {
                  hoursLeft = 24 - hour + 10;
              }
        }
        if(dayOfWeek==6) { //Saturday
              if(hour < 10) {
                hoursLeft = 10 - hour;
              } else {
                  hoursLeft = 24 - hour + 10;
              }
        }
          if(dayOfWeek==0) { //Sunday
              if(hour < 10) {
                hoursLeft = 11 - hour;
              } else {
                  hoursLeft = 24 - hour + 10;
              }
        }
    
          return hoursLeft;
    }
    
    function validateEmail(email) {
        var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        return re.test(email);
    }
    
    function validateAddCart(form) {
      if(form.find('input[name=id]').val()=='') {
            var allOptionsSelected;
              if(form.find('.single-option-selector').length > 0) {
                allOptionsSelected = true;
                form.find('.single-option-selector').each(function(){
                    if($(this).val()=="") {
                        allOptionsSelected = false;
                        return false;
                    }
                });
            } else {
                  allOptionsSelected = false;
            }
              
              if(allOptionsSelected) {
                  var errorMsg = form.find('.validation-msg').text();
                  if(errorMsg) {
                      alert(errorMsg);
                } else {
                    alert("The selected variant is sold out.");
                }
            } else {
                var labels = [];
                form.find('.options label').each(function(key, obj){
                    labels.push($(obj).text().replace(':', '').trim());
                });
                alert("You must select a "+labels.join('/')+".");
            }
              return false;
        }
          return true;
    }
    
    function initSideCart() {
        /**
      $('.header .cart-wrap').click(function(e){
          e.stopPropagation();
          showSideCart(true);
          return false;
        });
        */
    
        $(document).click(function(event){
          if(!$(event.target).closest('#side-cart').length && $(event.target).attr('id')!="add-cart-overlay" && $('#side-cart').hasClass('open')) {
            hideSideCart();
          }
        });
    
        $('body').delegate('#side-cart a.remove-from-cart', 'click', function(){
          var variantId = $(this).attr('href').replace('#', '');
          
          
              location = '/cart/change/'+variantId+'?quantity=0';
          
          
          return false;
        });
    }
    
    /**
     * Page-specific call-backs
     * Called after dom has loaded.
     */
    var RADIANCE = {
    
        common : {
            init: function(){
                $('html').removeClass('no-js').addClass('js');
                setupDropdownMenus();
    
                $('.nav-arrow', '#top-menu').each( function(){
                    $(this).css('top', Math.ceil($(this).parent(2).height()/2) + 1);
                });
    
            }
        },
    
        templateIndex : {
            init: function(){
    
            }
        },
    
        templateProduct : {
            init: function(){
                //$('#product-actions').bind( 'submit', addToCart );
                $('#thumbs li:nth-child(5n+5)').addClass('last-in-row');
            }
        },
    
        /** templateCart : {
            init: function(){
              var checkGiftNote = function() {
                  if($('#chk-is-gift').is(':checked')) {
                      $('#is-gift').val('Yes');
                        $('#gift-note').show();
                  } else {
                      $('#is-gift').val('No');
                      $('#gift-note').hide();
                      $('#gift-note').find('textarea').val("");
                  }
              }
              $('#chk-is-gift').click(function(){
                    checkGiftNote();
              });
              checkGiftNote();
            }
        }**/
    
    }
    
    var UTIL = {
    
        fire : function(func,funcname, args){
            var namespace = RADIANCE;
            funcname = (funcname === undefined) ? 'init' : funcname;
            if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
                namespace[func][funcname](args);
            }
        },
    
        loadEvents : function(){
            var bodyId = document.body.id;
    
            // hit up common first.
            UTIL.fire('common');
    
            // do all the classes too.
            $.each(document.body.className.split(/\s+/),function(i,classnm){
                UTIL.fire(classnm);
                UTIL.fire(classnm,bodyId);
            });
        }
    
    };
    $(document).ready(UTIL.loadEvents);
    
    /**
     * Support for dropdown menus
     */
    function setupDropdownMenus(){
        $('.menu-container .has-dropdown').hoverIntent( navRollOver, navRollOut );
    
        function navRollOver(e){
            $(this).addClass('active').find('ul:first').slideDown();
        }
        function navRollOut(e){
            $(this).removeClass('active').find('ul:first').slideUp();
        }
    }
    
    function setupDropdownMenus(){
        $('.menu-container .custom-dropdown').hoverIntent( navRollOver, navRollOut );
    
        function navRollOver(e){
            $(this).addClass('active').find('div:first').slideDown();
        }
        function navRollOut(e){
            $(this).removeClass('active').find('div:first').slideUp();
        }
    }
    
    /**
     * Ajaxy add-to-cart
     */
    function addToCart(form){
        $('#add-cart-overlay').fadeIn();
          $.fancybox.close();
    
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          //async: false,
          data: form.serialize(),
          dataType: 'json',
          error: addToCartFail,
          success: addToCartSuccess,
          cache: false
        });
          
    }
    
    function addToCartSuccess(jqXHR, textStatus, errorThrown){
        updateCartDesc();
    }
    
    function addToCartFail(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          $('#add-cart-overlay').fadeOut();
        var quantity = $('#product-qty').data('quantity');
          var errorMsg;
          
          if(response.status==422) {
              if(quantity && quantity > 0) {
                errorMsg = 'There are only ' + quantity + ' of this item in Stock. Please adjust your Quantity';
            } else {
                errorMsg = 'All the in stock items of this product are already in your cart.';
            }
        } else {
            errorMsg = response.description;
        }
      
          $.fancybox('<div class="error-itemincart">'+errorMsg+'</div>', {
          padding: 0,
          margin: [40,30,20,10],
          closeEffect: 'fade',
          autoCenter: true,
          helpers: {
            overlay: { speedOut : 500 }
          }
        });
    }
    
    function removeItemToCart(variantId){
          $('#add-cart-overlay').fadeIn();
    
        $('#side-cart').remove();
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
              data: {
              id: variantId,
              quantity: 0
            },
            dataType: 'json',
              error: function(){
                  updateCartDesc();
                  $('#add-cart-overlay').fadeOut();
              },
              success: function(){
                  updateCartDesc();
                  $('#add-cart-overlay').fadeOut();
              },
            cache: false
        });
    }
    
    function updateCartDesc(){  
      $.ajax({
        type: 'GET',
        url: '/cart?view=side-cart',
        cache: false,
        success: function(data){
          $('#add-cart-overlay').fadeOut();
    
          var animate = true;
          if($('#side-cart').width()>0) {
            animate = false;
          }
          $('#side-cart').remove();
          $('#page').append(data);
          $.fancybox.close();
          showSideCart(animate);
        }
      });
      
      $.ajax({
        type: 'GET',
        url: '/cart?view=popup',
        cache: false,
        success: function(data){
          $('#cart-popup-content .cart-popup-container').remove();
          $('#cart-popup-content').append(data);
        }
      });
    }
    
    function showSideCart(animate) {
      $('body, html').css({overflow: 'hidden'});
      $('#side-cart').addClass('open');
      $('#page').addClass('mode-overlay');
    }
    
    function hideSideCart() {
      $('#side-cart').removeClass('open');
      $('#page').removeClass('mode-overlay');
      $('body, html').css({overflow: ''});
    }
    
    $(function(){
    
      $('.bottom-columns .title-related').click( function(){
        $('.bottom-columns .size_charts').hide();
        $('.bottom-columns .delivery_returns').hide();
        $('.bottom-columns .related').show();
        $('.bottom-columns .title-related').addClass('active');
        $('.bottom-columns .title-charts').removeClass('active');
        $('.bottom-columns .title-delivery').removeClass('active');
        return false;
      });
      
      $('.bottom-columns .title-charts').click( function(){
        $('.bottom-columns .size_charts').show();
        $('.bottom-columns .delivery_returns').hide();
        $('.bottom-columns .related').hide();
        $('.bottom-columns .title-related').removeClass('active');
        $('.bottom-columns .title-charts').addClass('active');
        $('.bottom-columns .title-delivery').removeClass('active');
        return false;
      });
      
      $('.bottom-columns .title-delivery').click( function(){
        $('.bottom-columns .size_charts').hide();
        $('.bottom-columns .delivery_returns').show();
        $('.bottom-columns .related').hide();
        $('.bottom-columns .title-related').removeClass('active');
        $('.bottom-columns .title-charts').removeClass('active');
        $('.bottom-columns .title-delivery').addClass('active');
        return false;
      });
      
      $('#linktosize').click( function(){
        $('.bottom-columns .size_charts').show();
        return false;
      });
      
      
      
    });
    
    $(function(){
      var acc = document.getElementsByClassName("accordion");
      var i;
    
      for (i = 0; i < acc.length; i++) {
        acc[i].onclick = function() {
          this.classList.toggle("active");
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight){
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          } 
        }
      }
    });
    
    $(function() {
        $('#accordion .content').hide();
        $('#accordion h2:first').addClass('active').next().slideDown('slow');
        $('#accordion h2').click(function() {
          if($(this).next().is(':hidden')) {
            $('#accordion h2').removeClass('active').next().slideUp('slow');
            $(this).toggleClass('active').next().slideDown('slow');
          }
        });
      });
    
    $(function(){
    
      $('#faq-page .left-menu .menu-ordering').click( function(){
        $('.box-ordering').show();   
        $('.box-payment').hide();
        $('.box-shipping').hide();
        $('.box-myaccount').hide();
        $('.box-promos').hide();
        $('.box-others').hide();
        $('#faq-page .left-menu .menu-ordering').addClass('active');
        $('#faq-page .left-menu .menu-payment').removeClass('active');
        $('#faq-page .left-menu .menu-shipping').removeClass('active');
        $('#faq-page .left-menu .menu-myaccount').removeClass('active');
        $('#faq-page .left-menu .menu-promos').removeClass('active');
        $('#faq-page .left-menu .menu-others').removeClass('active');
        return false;
      });
      $('#faq-page .left-menu .menu-payment').click( function(){
        $('.box-ordering').hide();
        $('.box-payment').show();
        $('.box-shipping').hide();
        $('.box-myaccount').hide();
        $('.box-promos').hide();
        $('.box-others').hide();
        $('#faq-page .left-menu .menu-ordering').removeClass('active');
        $('#faq-page .left-menu .menu-payment').addClass('active');
        $('#faq-page .left-menu .menu-shipping').removeClass('active');
        $('#faq-page .left-menu .menu-myaccount').removeClass('active');
        $('#faq-page .left-menu .menu-promos').removeClass('active');
        $('#faq-page .left-menu .menu-others').removeClass('active');
        return false;
      });
      $('#faq-page .left-menu .menu-shipping').click( function(){
        $('.box-ordering').hide();
        $('.box-payment').hide();
        $('.box-shipping').show();
        $('.box-myaccount').hide();
        $('.box-promos').hide();
        $('.box-others').hide();
        $('#faq-page .left-menu .menu-ordering').removeClass('active');
        $('#faq-page .left-menu .menu-payment').removeClass('active');
        $('#faq-page .left-menu .menu-shipping').addClass('active');
        $('#faq-page .left-menu .menu-myaccount').removeClass('active');
        $('#faq-page .left-menu .menu-promos').removeClass('active');
        $('#faq-page .left-menu .menu-others').removeClass('active');
        return false;
      });
      $('#faq-page .left-menu .menu-myaccount').click( function(){
        $('.box-ordering').hide();
        $('.box-payment').hide();
        $('.box-shipping').hide();
        $('.box-myaccount').show();
        $('.box-promos').hide();
        $('.box-others').hide();
        $('#faq-page .left-menu .menu-ordering').removeClass('active');
        $('#faq-page .left-menu .menu-payment').removeClass('active');
        $('#faq-page .left-menu .menu-shipping').removeClass('active');
        $('#faq-page .left-menu .menu-myaccount').addClass('active');
        $('#faq-page .left-menu .menu-promos').removeClass('active');
        $('#faq-page .left-menu .menu-others').removeClass('active');
        return false;
      });
      $('#faq-page .left-menu .menu-promos').click( function(){
        $('.box-ordering').hide();
        $('.box-payment').hide();
        $('.box-shipping').hide();
        $('.box-myaccount').hide();
        $('.box-promos').show();
        $('.box-others').hide();
        $('#faq-page .left-menu .menu-ordering').removeClass('active');
        $('#faq-page .left-menu .menu-payment').removeClass('active');
        $('#faq-page .left-menu .menu-shipping').removeClass('active');
        $('#faq-page .left-menu .menu-myaccount').removeClass('active');
        $('#faq-page .left-menu .menu-promos').addClass('active');
        $('#faq-page .left-menu .menu-others').removeClass('active');
        return false;
      });
      $('#faq-page .left-menu .menu-others').click( function(){
        $('.box-ordering').hide();
        $('.box-payment').hide();
        $('.box-shipping').hide();
        $('.box-myaccount').hide();
        $('.box-promos').hide();
        $('.box-others').show();
        $('#faq-page .left-menu .menu-ordering').removeClass('active');
        $('#faq-page .left-menu .menu-payment').removeClass('active');
        $('#faq-page .left-menu .menu-shipping').removeClass('active');
        $('#faq-page .left-menu .menu-myaccount').removeClass('active');
        $('#faq-page .left-menu .menu-promos').removeClass('active');
        $('#faq-page .left-menu .menu-others').addClass('active');
        return false;
      });
      $('.over-carousel .brands').click( function(){
        $('.brands-popup').show();
        $(".brands").css("right", "0");
        $('.chat-popup').hide();
        $(".chat").css("right", "-10px");
        $('.iwish-popup').hide();
        $(".iwish").css("right", "-10px");
        $('.cart-popup').hide();
        $(".to-cart").css("right", "-10px");
      });
      $('.over-carousel .to-cart').click( function(){
        $('.cart-popup').show();
        $(".to-cart").css("right", "0");
        $('.chat-popup').hide();
        $(".chat").css("right", "-10px");
        $('.iwish-popup').hide();
        $(".iwish").css("right", "-10px");
        $('.brands-popup').hide();
        $(".brands").css("right", "-10px");
      });
      $('.over-carousel .brands .brands-popup .close-popup').click( function(){
        $('.brands-popup').hide();
        $(".brands").css("right", "-10px");
        return false;
      });
      $('.over-carousel .chat').click( function(){
        $('.chat-popup').show();
        $(".chat").css("right", "0");
        $('.brands-popup').hide();
        $(".brands").css("right", "-10px");
        $('.iwish-popup').hide();
        $(".iwish").css("right", "-10px");
        $('.cart-popup').hide();
        $(".to-cart").css("right", "-10px");
      });
      $('.over-carousel .chat .chat-popup .close-popup').click( function(){
        $('.chat-popup').hide();
        $(".chat").css("right", "-10px");
        return false;
      });
      $('.over-carousel .iwish').click( function(){
        $('.iwish-popup').show();
        $(".iwish").css("right", "0");
        $('.brands-popup').hide();
        $(".brands").css("right", "-10px");
        $('.chat-popup').hide();
        $(".chat").css("right", "-10px");
        $('.cart-popup').hide();
        $(".to-cart").css("right", "-10px");
        
        //Load items
        if(wishlist.getItemsCount() > 0) {
              $('.iwish-popup .items').html("");
              $('.iwish-popup .loading').removeClass('hide');
              wishlist.getMyWishlist(function(items){
                  var noImageUrl = '//www.ladida.com/cdn/shop/t/164/assets/wishlist-no-image.gif?49528';
                  var html = '<div class="grid">';
                  $.each(items, function(){
                      html += '<div class="grid__item one-half">';
                    html += '<a href="/products/'+this.handle+'?variant='+this.variant.id+'"><img src="'+(this.img=='no-image' ? noImageUrl : this.img)+'" /></a>';
                    html += '</div>';
                  });
                  html += '</div>';
                  $('.iwish-popup .items').append(html);
                  $('.iwish-popup .loading').addClass('hide');
            }, 4);
        }
      });
      $('.over-carousel .iwish .iwish-popup .close-popup').click( function(){
        $('.iwish-popup').hide();
        $(".iwish").css("right", "-10px");
        return false;
      });
    });
    
    $(function(){
        $(".header .cart-wrap").hover(
          function() {
            $( this ).find('.cart-count').addClass( "animated jello" );
          },
          function() {
            $( this ).find('.cart-count').removeClass( "animated jello" );
          }
        );
    
        $('.search-target').click( function(){
          $('body').css({'overflow': 'hidden'});
          $('#search-fullscreen').fadeIn();
          $('#search-fullscreen .form').show().addClass('');
          $('#search-fullscreen i.lnr-cross').fadeIn();
          $('#search-fullscreen .input-search').focus();
          return false;
        });
    
        $('#search-fullscreen i.lnr-cross').click( function(){
          $('body').css({'overflow': 'auto'});
          $('#search-fullscreen .form').fadeOut().removeClass('');
          $('#search-fullscreen i.fa-close').fadeOut();
          $('#search-fullscreen').fadeOut();
          return false;
        });
    
        $('.tel-target').click( function(){
          $('body').css({'overflow': 'hidden'});
          $('#contact-fullscreen').fadeIn();
          $('#contact-fullscreen .form').show().addClass('');
          $('#contact-fullscreen i.lnr-cross').fadeIn();
          $('#contact-fullscreen .input-search').focus();
          return false;
        });
    
        $('#contact-fullscreen i.lnr-cross').click( function(){
          $('body').css({'overflow': 'auto'});
          $('#contact-fullscreen .form').fadeOut().removeClass('');
          $('#fullscreen i.fa-close').fadeOut();
          $('#contact-fullscreen').fadeOut();
          return false;
        });
      
        $('#contact-fullscreen-small i.lnr-cross').click( function(){
            $('body').css({'overflow': 'auto'});
            $('#contact-fullscreen-small .form').fadeOut().removeClass('');
            $('#fullscreen i.fa-close').fadeOut();
            $('#contact-fullscreen-small').fadeOut();
            return false;
          });
    
        $('.search-form').on('submit', function(e){
          e.stopPropagation();
          e.preventDefault();
          var query = $(this).serialize();
          window.location = '/search?'+query;
        });
    
        $('.newsletter-target').click( function(){
          $('body').css({'overflow': 'hidden'});
          $('#mailing-fullscreen').fadeIn();
          $('#mailing-fullscreen .form').show().addClass('');
          $('#mailing-fullscreen i.lnr-cross').fadeIn();
          $('#mailing-fullscreen .input-text').focus();
          return false;
        });
    
        $('#mailing-fullscreen i.lnr-cross').click( function(){
          $('body').css({'overflow': 'auto'});
          $('#mailing-fullscreen .form').fadeOut().removeClass('');
          $('#mailing-fullscreen i.fa-close').fadeOut();
          $('#mailing-fullscreen').fadeOut();
          return false;
        });
    
        $('.ourhours').click( function(){
          $('body').css({'overflow': 'hidden'});
          $('#contact-fullscreen').fadeIn();
          $('#contact-fullscreen .form').show().addClass('');
          $('#contact-fullscreen i.lnr-cross').fadeIn();
          $('#contact-fullscreen .input-search').focus();
          return false;
        });
    
        $('#footer .footermenu .contact-target').click( function(){
          $('body').css({'overflow': 'hidden'});
          $('#contact-fullscreen').fadeIn();
          $('#contact-fullscreen .form').show().addClass('');
          $('#contact-fullscreen i.lnr-cross').fadeIn();
          $('#contact-fullscreen .input-search').focus();
          return false;
        });
      
        $('#product-info #accordion .contact-target-small').click( function(){
          $('body').css({'overflow': 'hidden'});
          $('#contact-fullscreen-small').fadeIn();
          $('#contact-fullscreen-small .form').show().addClass('');
          $('#contact-fullscreen-small i.lnr-cross').fadeIn();
          $('#contact-fullscreen-small .input-search').focus();
          return false;
        });
      
        $('#prodbottomchanger .showone').click( function(){
          $('#prodbottomchanger .showone').addClass('active');
          $('#prodbottomchanger .showtwo').removeClass('active');
          $('.item').addClass('showonlyoneitem');
          return false;
        });
      
        $('#prodbottomchanger .showtwo').click( function(){
          $('#prodbottomchanger .showtwo').addClass('active');
          $('#prodbottomchanger .showone').removeClass('active');
          $('.item').removeClass('showonlyoneitem')
          return false;
        });
      
        $('#small-showfilters').click( function(){
          $('#collection .filter').css("display", "block");
          return false;
        });
        $('#closebox').click( function(){
          $('#collection .filter').css("display", "none");
          return false;
        });
        $('#small-showfilters').click( function(){
            $('#searchresults .filter').css("display", "block");
            return false;
          });
          $('#closebox').click( function(){
            $('#searchresults .filter').css("display", "none");
            return false;
          });
      
          
        $('#contact-fullscreen form.contact-form').submit(function(e){
    
          e.preventDefault();
          e.stopImmediatePropagation();
    
          $(this).find('.error').removeClass('error');
          var field;
          var errors = false;
    
          field = $(this).find('.name');
          if(field.val()=='') {
            field.addClass('error');
            errors = true;
          }
    
          field = $(this).find('.email');
          if(!validateEmail(field.val())) {
            field.addClass('error');
            errors = true;
          }
          if(field.val()=='') {
            field.addClass('error');
            errors = true;
          }
    
          field = $(this).find('.phone');
          if(field.val()=='') {
            field.addClass('error');
            errors = true;
          }
    
          field = $(this).find('.message');
          if(field.val()=='') {
            field.addClass('error');
            errors = true;
          }
    
          if(errors) {
            return false;
          }
    
          var form = $(this);
          $.ajax({
            url: form.attr('action'),
            data: form.serialize(),
            type: 'POST'
          }).done(function(){
            $('#contact-fullscreen form.contact-form').fadeOut(function(){
              $('#contact-fullscreen .form-success').fadeIn();
            });
          });
        });
      
        $('#contact-fullscreen-small form.contact-form').submit(function(e){
    
          e.preventDefault();
          e.stopImmediatePropagation();
    
          $(this).find('.error').removeClass('error');
          var field;
          var errors = false;
    
          field = $(this).find('.name');
          if(field.val()=='') {
            field.addClass('error');
            errors = true;
          }
    
          field = $(this).find('.email');
          if(!validateEmail(field.val())) {
            field.addClass('error');
            errors = true;
          }
          if(field.val()=='') {
            field.addClass('error');
            errors = true;
          }
    
          field = $(this).find('.phone');
          if(field.val()=='') {
            field.addClass('error');
            errors = true;
          }
    
          field = $(this).find('.message');
          if(field.val()=='') {
            field.addClass('error');
            errors = true;
          }
    
          /*field = $(this).find('.questionabout');
          if(field.val()=='') {
            field.addClass('error');
            errors = true;
          }*/
    
          if(errors) {
            return false;
          }
    
          var form = $(this);
          $.ajax({
            url: form.attr('action'),
            data: form.serialize(),
            type: 'POST'
          }).done(function(){
            $('#contact-fullscreen form.contact-form').fadeOut(function(){
              $('#contact-fullscreen .form-success').fadeIn();
            });
            $('#contact-fullscreen-small ul#contact-form').fadeOut(function(){
              $('#contact-fullscreen-small .form-success').fadeIn();
              $('#contact-fullscreen-small').addClass('success-form');
            });
          });
        });
    
    
      });
    
    function getQueryParam(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    
    
    